import React from 'react'
import { useTranslation } from 'react-i18next'

import ExportButton from '../../../../components/ExportButton/ExportButton'

import prizeIcon from './i/prize.svg'

import styles from './Header.module.scss'

const Header = ({ rewards, onSaveCSV }) => {
    const { t } = useTranslation()

    return (
        <div className={styles.header}>
            <div className={styles.headerLeft}>
                <div className={styles.title}>
                    <img src={prizeIcon} alt="prize" />
                    {t('Prize distribution')}
                </div>
                {/*<div className={styles.note}>*/}
                {/*    {t('Total wins')}: {rewards.totalWins}*/}
                {/*</div>*/}
            </div>
            <div className={styles.headerRight}>
                <ExportButton onClick={onSaveCSV} />
            </div>
        </div>
    )
}

export default Header
